var map = {
	"./ambiguus-tiles/ambiguus-tiles.json": 5644,
	"./coraetor/coraetor.json": 4865,
	"./dot/dot.json": 3080,
	"./isle-of-reflections/isle-of-reflections.json": 5431,
	"./moleculight/moleculight.json": 5591,
	"./murmuration/murmuration.json": 6991,
	"./palette/palette.json": 7144,
	"./phantom/phantom.json": 7623,
	"./pneuglove/pneuglove.json": 8530,
	"./rolling-pixels/rolling-pixels.json": 9914,
	"./snow-clock/snow-clock.json": 7576,
	"./sound-pocket/sound-pocket.json": 7957,
	"./tf-shell/tf-shell.json": 3046,
	"./time-to-snow/time-to-snow.json": 4233,
	"./transwall-fishtank/transwall-fishtank.json": 9708,
	"./under-the-cherry-blossom/under-the-cherry-blossom.json": 6258,
	"./wish-blossom/wish-blossom.json": 1656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4569;